import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTimes, FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';
import './Toast.css';

const Toast = ({ visible, message, type = 'info', onClose, actionLabel, actionTo, autoHideMs = 4000 }) => {
  useEffect(() => {
    if (!visible || !autoHideMs) return;
    const t = setTimeout(onClose, autoHideMs);
    return () => clearTimeout(t);
  }, [visible, autoHideMs, onClose]);

  if (!visible) return null;

  const Icon = type === 'success' ? FaCheckCircle : type === 'error' ? FaExclamationCircle : FaInfoCircle;

  return (
    <div className={`toast toast-visible toast-${type}`} role="alert" aria-live="polite">
      <div className="toast-icon">
        <Icon />
      </div>
      <div className="toast-content">
        <p className="toast-message">{message}</p>
        {actionLabel && actionTo && (
          <Link to={actionTo} className="toast-action" onClick={onClose}>
            {actionLabel}
          </Link>
        )}
      </div>
      <button
        type="button"
        className="toast-close"
        onClick={onClose}
        aria-label="Dismiss"
      >
        <FaTimes />
      </button>
      <div className="toast-progress" style={{ animationDuration: `${autoHideMs}ms` }} />
    </div>
  );
};

export default Toast;
